export default "__VITE_ASSET__DX5E8iLv__"